module.exports = __webpack_public_path__ + "static/media/photo.9bd3abe0.svg";